<template>

  <v-card color="#f5f5f5" v-observe-visibility="visibilityChanged">
    <v-toolbar tabs fixed light color="white">
      <v-btn icon @click.native="closeDialog" light>
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title v-if="selectedItem.id === 0">Add Product Listing</v-toolbar-title>
      <v-toolbar-title v-else>Edit Product Listing - {{selectedItem.reference}}</v-toolbar-title>
      <v-spacer/>

      <v-tabs slot="extension"
              v-model="activeTab"
              color="secondary"
              dark
              slider-color="primary"
              class="fixSides"
      >
        <v-tab>PRODUCT LISTING</v-tab>
        <v-tab>PRICE CALCULATIONS</v-tab>
      </v-tabs>

      <v-toolbar-items>
        <v-menu
          transition="slide-y-transition"
          :nudge-bottom="20"
          :nudge-right="0"
          :nudge-left="0">
          <v-btn @click="openBottomSheet($vuetify.breakpoint.mdAndDown)" id="menu-button"
                 slot="activator"
                 icon>

            <v-icon dark>more_vert</v-icon>
          </v-btn>
          <v-list v-show="$vuetify.breakpoint.lgAndUp">
            <v-list-tile @click.native="saveAll()">
              <v-list-tile-title>
                <v-icon color="secondary">save</v-icon>
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click.native="deleteAll()">
              <v-list-tile-title>
                <v-icon color="red">delete</v-icon>
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>

    </v-toolbar>

    <v-tabs-items class="fromTop" v-model="activeTab">
      <v-tab-item>

        <v-layout wrap>
          <v-container grid-list-md>
            <v-flex xs12 md10 offset-md1 xl6 offset-xl3>
              <v-hover>
                <v-card slot-scope="{ hover }"
                        :class="`elevation-${hover ? 4 : 1}`">
                  <v-card-title class="headline">{{cardTitle}} Product Listing
                    <v-spacer></v-spacer>
                  </v-card-title>

                  <v-card-title>

                    <v-flex xs12 pr-3 pl-3>
                      <v-layout row wrap>
                        <v-flex xs6>
                        <v-subheader>Product</v-subheader>
                        </v-flex>
                        <v-flex xs6>
                          <v-layout>
                            <v-spacer/>
                            <v-btn flat small color="secondary" @click.native="openProductDialog()">
                              Edit
                              <v-icon color="primary" right>edit</v-icon>
                            </v-btn>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-divider></v-divider>
                    </v-flex>

                    <v-flex xs12 md6 pl-4 pa-2>
                      <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                      >

                        <v-text-field v-if="!tabsDisabled"
                                      label="Reference"
                                      v-model="selectedItem.reference"
                                      counter
                                      maxlength="255"
                                      :disabled="!tabsDisabled"
                        />
                        <v-text-field v-else
                                      label="Reference"
                                      v-model="selectedItem.reference"
                                      counter
                                      maxlength="255"
                                      :disabled="!tabsDisabled"
                                      :rules="rules"
                        />

                      </v-form>
                    </v-flex>
                    <v-flex xs12 md6 pl-4 pa-2>
                      <v-autocomplete
                        clearable
                        :items="getManufacturers"
                        label="Manufacturer"
                        v-model="selectedItem.manufacturers_id"
                        item-value="id"
                        item-text="name"
                        :disabled="!tabsDisabled"
                        :loading="loading"
                      />
                    </v-flex>

                    <v-flex xs12 pr-3 pl-3>
                      <v-subheader>Product Details</v-subheader>
                      <v-divider/>
                    </v-flex>

                    <v-flex xs12 md6 pl-4 pa-2>
                      <v-text-field
                        suffix="kg"
                        label="Net Weight"
                        v-model="selectedItem.weight"
                        type="number"
                        step=".01"
                        min="0"
                        readonly
                      />
                    </v-flex>

                    <v-flex xs12 md6 pl-4 pa-2>
                      <v-text-field
                        label="HSCode"
                        v-model="selectedItem.hscode"
                        counter
                        maxlength="255"
                        readonly
                      />
                    </v-flex>

                    <v-flex xs12 pl-4 pa-2>
                      <v-textarea
                        auto-grow
                        rows="1"
                        label="Product Description"
                        v-model="selectedItem.product_description.description"
                        counter
                        maxlength="500"
                        readonly
                      />
                    </v-flex>

                    <v-flex xs12 pr-3 pl-3>
                      <v-subheader>Shopify Details</v-subheader>
                      <v-divider/>
                    </v-flex>

                    <v-flex xs12 md6 pl-4 pa-2>
                      <v-text-field
                        label="ShopifyID"
                        v-model="selectedItem.shopify_id"
                        readonly
                      />
                    </v-flex>

                    <v-flex xs12 md6 pl-4 pa-2>

                    </v-flex>

                    <v-flex xs12 md6 pl-4 pa-2>
                      <v-text-field
                        suffix="EUR"
                        label="Price"
                        v-model="selectedShopifyProduct.price"
                        type="number"
                        step=".01"
                        min="0"
                        readonly
                      />
                    </v-flex>

                    <v-flex xs12 md6 pl-4 pa-2>
                      <v-text-field
                        label="Inventory Quantity"
                        v-model="selectedShopifyProduct.inventory_quantity"
                        type="number"
                        step="1"
                        min="1"
                        readonly
                      />
                    </v-flex>

                  </v-card-title>
                  <v-card-actions>
                    <v-layout mt-2 pb-3 pr-3>
                      <v-spacer/>
                      <v-btn v-if="selectedItem.shopify_id"
                             :loading="loading" dark color="error" @click.native="deleteProductListing()">
                        Delete Listing
                        <v-icon class="white--text" right>save</v-icon>
                      </v-btn>
                      <v-btn :loading="loading" dark color="secondary" @click.native="saveProductListing()">
                        Save
                        <v-icon class="white--text" right>save</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-card-actions>

                </v-card>
              </v-hover>
              <v-layout mt-5 row justify-end>

              </v-layout>

            </v-flex>

          </v-container>
        </v-layout>
      </v-tab-item>
                  <v-tab-item>
                      <priceCalculations/>
                  </v-tab-item>

    </v-tabs-items>

    <addProductDialog :dontResetSelectedItem="true"/>

  </v-card>

</template>

<script>
import {
  Settings,
  ManufacturersSettings,
  ProductSettings,
  ProductListings
} from '../../store/namespace-helper'

import addProductDialog from '../Settings/Products/AddProductDialog.vue'
import priceCalculations from '../ProductListings/ProductListingsPriceCalculations/ProductListingsPriceCalculations.vue'

import _ from 'lodash'

export default {
  components: {
    addProductDialog,
    priceCalculations
  },
  name: 'add-product',
  data () {
    return {
      activeTab: 0,
      countries: this.$store.getters.countries,
      customContactFilter (item, queryText, itemText) {
        const isMatch = (test, query) => {
          return test.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
        }
        const query = queryText || ''
        const displayText = item.title + ' ' + item.firstname + ' ' + item.lastname
        const rc = isMatch(item.firstname, query) ||
            isMatch(item.lastname, query) ||
            isMatch(item.email, query) ||
            isMatch(displayText, query)
        console.log(`filter: ${JSON.stringify(item)}, '${query}', ${JSON.stringify(itemText)} => ${rc}`)
        return rc
      },
      isVisible: false,
      onDismissed: false,
      sheet: false,
      referenceNotFound: false,
      valid: true,
      rules: [
        v => this.referenceNotFound || 'Reference already existing.'
      ],
      selectedShopifyProduct: {
        price: '0.00',
        inventory_quantity: 0
      }
    }
  },
  methods: {
    visibilityChanged (isVisible, entry) {
      if (this.isVisible !== isVisible) {
        this.isVisible = isVisible
        if (isVisible) {
          console.log('tab visible, load data')
          this.loadManufacturers()
          this.loadSelectedShopifyProduct()
        } else {
          this.supplierUpdated = 0
        }
      }
    },
    closeDialog () {
      this.$store.dispatch(ProductListings.actions.openCloseDialog)
      this.$store.dispatch(ProductSettings.actions.setSelectedProduct, null)
      this.activeTab = 0
    },
    openProductDialog () {
      this.$store.dispatch(ProductSettings.actions.openCloseDialog)
    },
    searchThrottledReferences: _.debounce(function (val) {
      return this.searchReference(val)
    }, 450),
    loadManufacturers () {
      this.$store.dispatch(ManufacturersSettings.actions.loadAllManufacturers)
    },
    loadSelectedShopifyProduct () {
      this.$store.dispatch(ProductListings.actions.loadProduct, this.selectedItem).then(response => {
        if (response &&
            response.product &&
            response.product.variants &&
            response.product.variants[0]) {
          this.selectedShopifyProduct.price = response.product.variants[0].price
          this.selectedShopifyProduct.inventory_quantity = response.product.variants[0].inventory_quantity
        }
        console.log(response)
      }).catch(function (err) {
        console.log(JSON.stringify(err))
      })
    },
    searchReference (val) {
      const searchProduct = {
        search: val
        /*    fulltext: true */
      }
      this.$store.dispatch(ProductSettings.actions.loadAllProducts, searchProduct).then(response => {
        if (response.length > 0) {
          this.referenceNotFound = false
          this.$refs.form.validate()
        } else {
          this.referenceNotFound = true
          this.$refs.form.resetValidation()
        }
      }).catch(function (err) {
        console.log(JSON.stringify(err))
      })
    },
    saveProductListing () {
      this.$store.dispatch(ProductListings.actions.saveProduct, {
        product_id: this.selectedItem.id,
        shopify_id: this.selectedItem.shopify_id,
        product_price: this.selectedShopifyProduct.price,
        product_quantity: this.selectedShopifyProduct.inventory_quantity
      }).then(response => {
        this.loadSelectedShopifyProduct()
      })
    },
    deleteProductListing () {
      this.$store.dispatch(ProductListings.actions.deleteProduct, {
        product_id: this.selectedItem.id,
        shopify_id: this.selectedItem.shopify_id,
        product_price: this.selectedShopifyProduct.price,
        product_quantity: this.selectedShopifyProduct.inventory_quantity
      }).then(response => {
        this.loadSelectedShopifyProduct()
      })
    },
    openBottomSheet (payload) {
      if (payload) {
        this.$store.dispatch('openCloseBottomSheet')
      }
    }
  },
  computed: {
    dialog () {
      return this.$store.getters[ProductListings.getters.getDialogState]
    },
    selectedItem () {
      console.log('selected product: ' + JSON.stringify(this.$store.getters[ProductSettings.getters.getSelectedProduct]))
      return this.$store.getters[ProductSettings.getters.getSelectedProduct]
    },
    loading () {
      return this.$store.getters[Settings.getters.loading]
    },
    tabsDisabled () {
      return this.$store.getters[ProductSettings.getters.getSelectedProduct].id === 0
    },
    getManufacturers () {
      return this.$store.getters[ManufacturersSettings.getters.getAllManufacturers]
    },
    cardTitle () {
      if (this.selectedItem.id === 0) {
        return 'Add new'
      } else {
        return 'Edit'
      }
    }
  },
  watch: {
    'selectedItem.reference':
        function (newVal, oldVal) {
          if (newVal !== '' && typeof newVal !== 'undefined') {
            this.searchThrottledReferences(newVal)
          } else {
            this.$refs.form.resetValidation()
          }
        }
  }

}
</script>

<style scoped>

  #menu-button {
    margin-top: 4px;
    width: 55px;
    height: 55px;
  }

  .fromTop {
    padding-top: 120px;
  }

  .fixSides::before {
    position: absolute;
    content: "";
    background-color: var(--secondary-color);
    height: 100%;
    width: 110vw;
    top: 0px;
    left: -24px;
  }

  .statusSelecter {
    width: 80px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Shared/AddProductListing.vue